import { Link } from "@tanstack/react-router";
import prettyBytes from "pretty-bytes";
import { FaCloud } from "react-icons/fa";
import { formatIsoDateStr } from "../../utils";
import Card from "./card";
import ViewDetailButton from "../viewDetailButton";

const DataVolumeCard = ({ dataVolume }: { dataVolume: any }) => {
  const totalSize = dataVolume.manifests.reduce((acc: number, m: any) => acc + m.size, 0);
  const numberOfManifests = dataVolume.manifests.length;

  return (
    <Card className="flex items-center">
      <div className="flex-grow">
        <Link
          to={`/data/volumes/${encodeURIComponent(dataVolume.public_id)}` as any}
          className="mb-2 text-2xl text-blue-200"
        >
          {dataVolume.name}
        </Link>
        <p className="text-sm text-blue-400">
          Manifests: {numberOfManifests} | Size:{" "}
          {prettyBytes(parseInt(totalSize))}
        </p>
        <p className="text-sm text-blue-400">
          Registered: {formatIsoDateStr(dataVolume.created_dt)} | Updated:{" "}
          {formatIsoDateStr(dataVolume.updated_dt)}
        </p>
      </div>
      <ViewDetailButton
        detailUrl={`/data/volumes/${encodeURIComponent(dataVolume.public_id)}`}
      />
    </Card>
  );
};

export default DataVolumeCard;
